/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CommentResponse from './CommentResponse';
import JobStatus from './JobStatus';

/**
 * The ActivityItem model module.
 * @module model/ActivityItem
 * @version V1
 */
class ActivityItem {
    /**
     * Constructs a new <code>ActivityItem</code>.
     * @alias module:model/ActivityItem
     */
    constructor() { 
        
        ActivityItem.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ActivityItem</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ActivityItem} obj Optional instance to populate.
     * @return {module:model/ActivityItem} The populated <code>ActivityItem</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ActivityItem();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('eventType')) {
                obj['eventType'] = ApiClient.convertToType(data['eventType'], 'String');
            }
            if (data.hasOwnProperty('eventTypeId')) {
                obj['eventTypeId'] = ApiClient.convertToType(data['eventTypeId'], 'Number');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('userName')) {
                obj['userName'] = ApiClient.convertToType(data['userName'], 'String');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('eventValue')) {
                obj['eventValue'] = ApiClient.convertToType(data['eventValue'], 'String');
            }
            if (data.hasOwnProperty('comment')) {
                obj['comment'] = CommentResponse.constructFromObject(data['comment']);
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = JobStatus.constructFromObject(data['status']);
            }
            if (data.hasOwnProperty('assigneeName')) {
                obj['assigneeName'] = ApiClient.convertToType(data['assigneeName'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ActivityItem</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ActivityItem</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['eventType'] && !(typeof data['eventType'] === 'string' || data['eventType'] instanceof String)) {
            throw new Error("Expected the field `eventType` to be a primitive type in the JSON string but got " + data['eventType']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        // ensure the json data is a string
        if (data['userName'] && !(typeof data['userName'] === 'string' || data['userName'] instanceof String)) {
            throw new Error("Expected the field `userName` to be a primitive type in the JSON string but got " + data['userName']);
        }
        // ensure the json data is a string
        if (data['eventValue'] && !(typeof data['eventValue'] === 'string' || data['eventValue'] instanceof String)) {
            throw new Error("Expected the field `eventValue` to be a primitive type in the JSON string but got " + data['eventValue']);
        }
        // validate the optional field `comment`
        if (data['comment']) { // data not null
          CommentResponse.validateJSON(data['comment']);
        }
        // validate the optional field `status`
        if (data['status']) { // data not null
          JobStatus.validateJSON(data['status']);
        }
        // ensure the json data is a string
        if (data['assigneeName'] && !(typeof data['assigneeName'] === 'string' || data['assigneeName'] instanceof String)) {
            throw new Error("Expected the field `assigneeName` to be a primitive type in the JSON string but got " + data['assigneeName']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
ActivityItem.prototype['id'] = undefined;

/**
 * @member {String} eventType
 */
ActivityItem.prototype['eventType'] = undefined;

/**
 * @member {Number} eventTypeId
 */
ActivityItem.prototype['eventTypeId'] = undefined;

/**
 * @member {String} description
 */
ActivityItem.prototype['description'] = undefined;

/**
 * @member {String} userName
 */
ActivityItem.prototype['userName'] = undefined;

/**
 * @member {Number} userId
 */
ActivityItem.prototype['userId'] = undefined;

/**
 * @member {Date} createdAt
 */
ActivityItem.prototype['createdAt'] = undefined;

/**
 * @member {String} eventValue
 */
ActivityItem.prototype['eventValue'] = undefined;

/**
 * @member {module:model/CommentResponse} comment
 */
ActivityItem.prototype['comment'] = undefined;

/**
 * @member {module:model/JobStatus} status
 */
ActivityItem.prototype['status'] = undefined;

/**
 * @member {String} assigneeName
 */
ActivityItem.prototype['assigneeName'] = undefined;






export default ActivityItem;

